export const COUNTRY_CONFIG = {
  NG: {
    code: "NG",
    name: "Nigeria",
    route: "/ng",
    currency: "NGN",
    locale: "en-NG",
  },
  KE: {
    code: "KE",
    name: "Kenya",
    route: "/ke",
    currency: "KES",
    locale: "en-KE",
  },
  GH: {
    code: "GH",
    name: "Ghana",
    route: "/gh",
    currency: "GHS",
    locale: "en-GH",
  },
  SO: {
    code: "SO",
    name: "Somalia",
    route: "/so",
    currency: "SOS",
    locale: "en-SO",
  },
  US: {
    code: "US",
    name: "United States",
    route: "/us",
    currency: "USD",
    locale: "en-US",
  },
  GLOBAL: {
    code: "GLOBAL",
    name: "Global",
    route: "/global",
    currency: "USD",
    locale: "en-US",
  },
};

export const SUPPORTED_COUNTRY_CODES = ["NG", "KE", "GH", "SO", "US"];

export const normalizeCountryCode = (countryCode) => {
  const code = String(countryCode || "").trim().toUpperCase();
  return SUPPORTED_COUNTRY_CODES.includes(code) ? code : "GLOBAL";
};

export const getCountryConfig = (countryCode) =>
  COUNTRY_CONFIG[normalizeCountryCode(countryCode)];

export const getCountryCodeFromPath = (pathname = "") => {
  const firstSegment = pathname.split("/").filter(Boolean)[0]?.toLowerCase();

  const routeMap = {
    ng: "NG",
    ke: "KE",
    gh: "GH",
    gf: "GH",
    so: "SO",
    us: "US",
    global: "GLOBAL",
  };

  return routeMap[firstSegment] || null;
};
